import React, {useState,useCallback,useEffect} from 'react'
import Typography from '@mui/material/Typography';
import imageCompression from "browser-image-compression";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import CircularProgress from '@mui/material/CircularProgress';
import {useDropzone} from 'react-dropzone'
import {Tools} from './Tools';
import {Theme} from './Theme';
import Alert from './Alert';
import Yesno from './Yesno';
import Ajax from './Ajax';

interface Props {
    owner_id?:number,
    img_id?:number,
    name?:string,
    data?:string,
	noHelper?:boolean,
    id:string,
    maxWidth?:number,
    maxHeight?:number,
    change(id:string,src:string):void,
}

let action:any = null;
let maxWidth:number = 640;

const DropImage:React.FC<Props> = (props)=> {
    const defSrc:string = "";
    const [img,setImg] = useState({
        img_id: 0,
        src: defSrc,
		isLoading: true,
        yesno: "",
    });
    const [alert,setAlert] = useState("");


    if( props.maxWidth ){
        maxWidth = props.maxWidth;
    } else {
        maxWidth = 1280;
    }

    const change = (src:string)=>{
        setImg({img_id:0,src:src,yesno:"",isLoading:false});
        props.change(props.id,src);
        if( src.length>3000000 ){
            setAlert("画像ファイルが大き過ぎるため、登録できない場合があります。")
        }
    }
    const confirmClear = ()=> {
        action = clear;
        setImg({...img,yesno:"この画像を削除します。\nよろしいですか？"})
    }
    const clear = ()=>{
        setImg({img_id:0,src:defSrc,yesno:"",isLoading:false});
        props.change(props.id,defSrc);
    }
    const confirmRotate = ()=> {
        action = rotate;
        setImg({...img,yesno:"時計回りに90度回転します。\nよろしいですか？"})
    }
    const rotate = ()=>{
        Ajax.send("image/rotate",{img_id:img.img_id,src:img.src},(res:any)=>{
            if( res.ok ){
                setImg({img_id:0,src:res.src,yesno:"",isLoading:false});
                props.change(props.id,res.src);
            }
        },(err:any)=>{
            //console.log("error!",err);
            setAlert("回転できませんでした。\n画像ファイルが大きすぎるかもしれません。");
        });
    }
    const closeAlert = ()=>{
        setAlert("");
    }
    const yes = ()=>{
        action();
    }
    const no = ()=>{
        setImg({...img,yesno:""});
    }
    const onDrop = useCallback( async (acceptedFiles) => {
		setImg({...img,isLoading:true});

        const reader = new FileReader()

        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
            // Do whatever you want with the file contents
            const base64Str = reader.result
            if( base64Str ){
                change( base64Str.toString() );
            }
        }
		try {
			const compressOptions = {
				maxSizeMB: 2,
				maxWidthOrHeight: maxWidth,
				fileType: "image/jpeg",
			};
			const compressedFile = await imageCompression(acceptedFiles[0], compressOptions);
			reader.readAsDataURL(compressedFile);
		} catch(e){
			//console.log(e);
			setImg({...img,img_id:0,src:'',isLoading:false});
			setAlert("このファイルは使用できません。ファイル形式またはサイズに問題があります。");
		}

		//reader.readAsBinaryString(acceptedFiles[0]);
        //reader.readAsDataURL(acceptedFiles[0]);        
    }, [])

    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

    useEffect( ()=>{
        if( props.data || props.data==="" ){
			//console.log("dropImage","1");
            setImg({img_id:0,src:props.data,yesno:"",isLoading:false});
        } else if( props.owner_id && props.img_id ){
			//console.log("dropImage","2",props.img_id);
            setImg({img_id:props.img_id,src:Tools.getStoreImg(props.owner_id,props.img_id),yesno:"",isLoading:false});
        } else {
			//console.log("dropImage","3");
			setImg({img_id:0,src:"",yesno:"",isLoading:false});
		}
    },[props.data,props.img_id]);

    let style:React.CSSProperties = {
        width:"100%",
        height:"100%",
        position:"relative",
        padding:"0",
        backgroundColor:"#F5F5F5",
        lineHeight:"0",
        maxWidth:String(maxWidth)+"px"
    };


	if( img.isLoading ){
		return (
			<div style={{position:"relative",minHeight:"200px",height:"100%",backgroundColor:"#F5F5F5"}}>
				<CircularProgress color="primary" style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%, -50%)"}}/>
			</div>
		)
	}

	if( img.src ){
        return (
        <React.Fragment>
            <div style={style}>
                <img src={img.src} style={{maxWidth:"100%",maxHeight:"100%"}}/>
                <Tooltip title="画像を取り消す"><IconButton onClick={confirmClear} style={{position:"absolute",top:"0",right:"0",backgroundColor:"gray",borderRadius:"0 0 0 0.25em",borderLeft:"1px solid white",borderBottom:"1px solid white",padding:"0"}}><ClearIcon style={{color:"white"}}/></IconButton></Tooltip>
                <Tooltip title="画像を回転する"><IconButton onClick={confirmRotate} style={{position:"absolute",bottom:"0",left:"0",backgroundColor:"gray",borderRadius:"0 0.25em 0 0",borderRight:"1px solid white",borderTop:"1px solid white",padding:"0"}}><RotateRightIcon style={{color:"white"}}/></IconButton></Tooltip>
            </div>
            <Alert mes={alert} close={closeAlert} isOpen={alert!==""}/>
            <Yesno mes={img.yesno} yes={yes} no={no} isOpen={img.yesno!==""}/>
        </React.Fragment>
        )
    }

    return (
        <div {...getRootProps()} style={{border:`3px dashed ${Theme.palette.primary.dark}`,padding:"3em 1em",textAlign:"center"}}>
            <input {...getInputProps()} />
            {props.name ?
                <Typography variant="subtitle1" style={{color:`${Theme.palette.primary.dark}`}}>{props.name}</Typography>
            :
                <Typography variant="subtitle1" style={{color:`${Theme.palette.primary.dark}`}}>画像を登録するにはここをクリック<br/>もしくはここに画像をドラッグして下さい</Typography>
            }
			{!props.noHelper &&
            <div style={{fontSize:"80%",color:`${Theme.palette.primary.dark}`}}>
                ※幅{maxWidth}pixel以上ある画像は自動的に縮小されます
            </div>
			}
			<Alert mes={alert} close={closeAlert} isOpen={alert!==""}/>
        </div>
    )
}

export default DropImage;